// extracted by mini-css-extract-plugin
export default {"title":"_7aee1c640d","bld":"b031d675e1"};